import { useCallback, useEffect, useState } from 'react'

import { BusinessRegistrationModel } from '@marketplace-web/domain/business-accounts-data'

import { useSession } from '@marketplace-web/shared/session'
import { getLocalStorageItem, removeLocalStorageItem } from '@marketplace-web/shared/browser'

import { REGISTRATION_FORM_STORAGE_KEY } from '../../../constants'

export const DEFAULT_VALUES = {
  businessRepresentative: {
    fullName: '',
    firstNames: '',
    lastName: '',
    birthday: '',
    nationality: {
      code: '',
      title: '',
    },
    country: {
      code: '',
      title: '',
    },
  },
  businessDetails: {
    legalCode: '',
    legalName: '',
    entityType: '',
    registrarName: '',
    vat: '',
    isVatDisabled: false,
  },
  addresses: {
    businessAddress: {
      postalCode: '',
      fullPostalCode: '',
      city: '',
      countryId: null,
      line1: '',
      line2: '',
    },
    legalRepresentativeAddress: {
      postalCode: '',
      fullPostalCode: '',
      city: '',
      countryId: null,
      line1: '',
      line2: '',
    },
    isSameLegalRepresentativeAddress: true,
    isBusinessEqualToPersonalAddress: false,
  },
  profile: {
    photoTempUuid: '',
    photoUrl: undefined,
    businessAccountName: '',
    phoneNumber: '',
    isPhoneNumberPersonal: false,
    email: '',
    isEmailPersonal: false,
  },
}

const useDefaultValues = () => {
  const [defaultValues, setDefaultValues] = useState<BusinessRegistrationModel>(DEFAULT_VALUES)
  const { user } = useSession()
  const storageData = getLocalStorageItem(REGISTRATION_FORM_STORAGE_KEY)

  useEffect(() => {
    if (!storageData && !user?.id) return

    const values = storageData
      ? {
          ...DEFAULT_VALUES,
          ...JSON.parse(storageData),
        }
      : DEFAULT_VALUES
    if (user && user.id) {
      const { real_name, birthday, photo } = user
      if (real_name && !values.businessRepresentative?.fullName) {
        values.businessRepresentative.fullName = real_name
      }
      if (birthday && !values.businessRepresentative?.birthday) {
        values.businessRepresentative.birthday = birthday
      }
      if (photo && !values.profile.photoUrl) {
        values.profile.photoUrl = photo.url
      }
    }
    setDefaultValues(values)
  }, [storageData, user, user?.id])

  const onClearDefaultValues = useCallback(() => {
    setDefaultValues(DEFAULT_VALUES)
    removeLocalStorageItem(REGISTRATION_FORM_STORAGE_KEY)
  }, [])

  return { defaultValues, onClearDefaultValues }
}

export default useDefaultValues
